import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { JEWELRY_DISPLAY } from './jewelrtDisplaysJson'
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";
import WhyLussopackMoreInfo from "../../../components/whyLussopack/whyLussoPackMoreInfo";


function JewelryDisplays(props) {  

  const descriptionContent = (
    <div className="descriptionContainer mb-5">
      <h2 className="mb-3">Jewelry Showcase Displays by Lussopack </h2>
      <p>Jewelry display sets whether it’s jewelry display racks, stands or trays are meticulously designed arrangements that serve as <a href='https://lussopack.com/packaging/jewelry-cases' target="_blank" rel='noopener noreferrer'>elegant showcases</a> for necklaces, earrings, bracelets, and rings. Lussopack’s jewelry display sets are crafted to captivate attention, combining functionality and aesthetics to create visually appealing and organized presentations. Perfect for luxury stores and trade shows, our displays come in various styles, <a href='https://lussopack.com/our-materials' target="_blank" rel='noopener noreferrer'>materials</a>, and configurations, providing solutions for different preferences.</p>
      <h2 className="mb-3 mt-5">Tailored Packaging Solutions for Necklaces, Rings, Earrings, and more  </h2>
      <p>Each type of jewelry benefits from a specific display that complements its features. Necklace display stands wholesale provide upright and refined presentations that showcase the intricate details of necklaces. For rings, ring displays wholesale create arrangements that highlight their design and brilliance. Likewise, earring display stands wholesale are designed to present both studs and dangling earrings in a clear and attractive way. Lussopack’s carefully crafted displays are ideal for creating an organized and appealing presentation for your collection.</p>
      <h2 className="mb-3 mt-5">Why Choose a Manufacturer for Jewelry Display Trays? </h2>
      <h3>Tailored Solutions </h3>
      <p>Manufacturers offer custom designs and branding to meet your specific needs, providing flexibility unavailable in standard retail options.</p>
      <h3>Reliable Quality</h3>
      <p>Directly sourced displays ensure durable materials and expert craftsmanship, creating a polished look for your collection.</p>
      <h3>Cost Savings </h3>
      <p>Buying from a manufacturer cuts out middleman expenses, offering wholesale prices ideal for bulk orders like jewelry display racks or ring stands.</p>
      <h3>Expert Advice</h3>
      <p>Manufacturers like Lussopack provide guidance to help you find the right displays, ensuring they align with your needs and goals.</p>
      <p>Choosing a manufacturer means professional-grade displays at competitive prices, tailored for your collection.</p>
    </div>
  );

  const summaryDescription = (
    <div className='summaryDescription'>
      <h2 className='mb-3 mt-5'>Lussopack: Your Custom Luxury Jewelry Display Partner</h2>
      <p>Based in Bangkok, Thailand, Lussopack is a leading luxury jewelry display manufacturer with over 30 years of expertise, delivering exceptional quality and personalized service.</p>
      <h3 className="mb-2">More Than Wholesale Jewelry Display Manufacturing</h3>
      <p>We work with clients to craft luxury jewelry display that fosters emotional connections, builds brand loyalty, and inspires advocacy.</p>
      <h3 className="mb-2">Broad Specialization</h3>
      <p>From jewelry packaging, and jewelry display to custom designs for high-end brands like perfume, rigid, and gift boxes, we ensure superior craftsmanship in every product.</p>
      <h3 className="mb-2">Tailor-Made Solutions</h3>
      <p>Choose from an extensive range of premium materials and finishes, or work with our experts to develop bespoke packaging that embodies your brand's essence.</p>
      <h3 className="mb-2">Efficient Logistics Services</h3>
      <p>Take advantage of our warehousing, distribution, and direct packaging solutions to streamline operations, cut costs, and manage your supply chain with ease.</p>
      <h3 className="mb-2">Client-Focused Commitment</h3>
      <p>At Lussopack, we are passionate about delivering flawless jewelry display solutions that align with your brand’s vision and exceed your expectations.</p>
      <h3 className="mb-2">Contact Us Today</h3>
      <p>Let us help bring your luxury jewelry display vision to life. Reach out to our team and discover how we can create the perfect solution for your brand.</p>
  </div>
  )

  return (
    <>
      <Helmet>
        <title>Jewelry Display Manufacturer - Tray, Stand, Rack | Lussopack</title>
        <meta name="description" content="Check out our wide range of luxury jewelry display showcases, including jewelry display stands, and more. Our displays make every piece a masterpiece." />
        <meta name="keywords" content="jewelry display manufacturer" />
        <link rel="canonical" href="https://lussopack.com/packaging/" />  
      </Helmet>
      
      <HeaderTitle
        {...props}
        textHeader={"Luxury Jewelry Showcase Display Sets"}
        textSubHeader={"Our jewelry showcase displays are designed to highlight the beauty of necklaces, earrings, bracelets, and rings, ensuring they shine and captivate attention."}
        isShowOurReference={true}
      />

      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="jewelryDisplays">
            <h2 className="text-center">Custom Jewelry Showcase Display</h2>
            <div className="jewelryDisplayList">
              {
                JEWELRY_DISPLAY.map((jewelry, index)=>(
                  <div className={`jewelryDisplayItem`} key={index}>
                    <Link to={toRoute(jewelry.path)}>
                      <Image
                        src={asset(`${jewelry.itemImageDesktop}`)}
                        alt={`${jewelry.item}`}
                        className="img-fluid zoom"
                        width="345"
                        height="345"
                      />
                    </Link>
                    <Link to={toRoute(jewelry.path)}>
                      <p className="text-center mt-2">{jewelry.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>

            {descriptionContent}            
            <WhyLussopackMoreInfo />
            {summaryDescription}

          </div>
        </Media>
        <Media lessThan="md">
          <div id="jewelryDisplaysMobile">
            <h2>Custom Jewelry Showcase Display</h2>
            <div className="jewelryDisplayList">
              {
                JEWELRY_DISPLAY.map((jewelry, index)=>(
                  <div className={`jewelryDisplayItem`} key={index}>
                    <Link to={toRoute(jewelry.path)}>
                      <Image
                        src={asset(`${jewelry.itemImageDesktop}`)}
                        alt={`${jewelry.item}`}
                        className="img-fluid"
                        width="345"
                        height="345"
                      />
                      <p>{jewelry.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
            {descriptionContent}              
            <WhyLussopackMoreInfo />
            {summaryDescription}
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default JewelryDisplays;
